var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.typeComponent,_vm._b({tag:"component",attrs:{"value":_vm.value,"isLat":_vm.isLat},on:{"input":_vm.inputValue}},'component',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }